import styled from "styled-components";

const DelegatesGridTableColumn = styled.td`
    width: ${({ width }) => width}%;
    padding: 0.6rem !important;
    vertical-align: middle;
`;

export default DelegatesGridTableColumn;